import React, { Component, useContext, useState } from "react";
import classes from './ControlsBarV2.module.css'
import ComponentCard from "../../Cards/ComponentCard/ComponentCard";
import userIcon from '../../../../assets/portalAssets/usericonW.png';
import resfreshIconw from '../../../../assets/portalAssets/refreshIconW.png';
import resfreshIconb from '../../../../assets/portalAssets/refreshIconB.png';
import UsersIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__User.svg"
import Dashboard from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/dashboard.png"
import LogsIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Logs.svg"
import AutomationsIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Automations.svg"
import EventsIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Events.svg"
import GroupsIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Groups.svg"
import RefreshTableIcon from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Refresh.svg"
import Settings from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Control Buttons Icons/__Admin - Settings.svg"
import VirtualSources from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Virtual Sources.svg"
import SmartLock from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Locked.svg"
import ControlsBarButton from "../ControlsBarButton/ControlsBarButton";
import ControlsBarRefreshButton from "../ControlsBarButton/ControlsBarRefreshButton";

import overviewIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/overview.png'
import usersIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/users.png'
import eventsIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/events.png'
import rulesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/rules.png'
import devicesIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/devices.png'
import configIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/config.png'
import analyticsIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/SiteView-ControlBar/analytics.png'

const ContorlsBarV2 = (props) => {

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {

        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const dummyButtons = [
        {
            key: "Overview",
            title: "Overview",
            path: overviewIcon
        },
        {
            key: "Users",
            title: `Users (${props.userCount})`,
            path: usersIcon,
        },
        {
            key:"Events",
            title: "Events",
            path: eventsIcon
        },
        // {
        //     key: "Analytics",
        //     title: "Analytics",
        //     path: analyticsIcon
        // },
        {
            key: "Rules",
            title: "Rules",
            path: rulesIcon

        },
        {
            key:"Devices",
            title: "Devices",
            path: devicesIcon

        },
        {
            key: "Config",
            title: "Config",
            path: configIcon
        },
    ]

    const table = null;

    const [activeButton, setActiveButton] = useState(props.activeTable)
    return (
        <div className={classes["ControlButtons-container"]}>
            <ul className={classes["tableButtons-list"]}>
                {dummyButtons.map((button, index) => (
                    <li key={index}>
                        <ControlsBarButton id={button.key} title={button.title} imagePath={button.path} onClick={props.tableNameHandler} activeButton={activeButton} setActiveButton={setActiveButton}/>
                    </li>
                ))}
                {/* <ControlsBarRefreshButton imagePath={RefreshTableIcon} handleMouseLeave={handleMouseLeave} handleMouseEnter={handleMouseEnter} HandleRefreshTable={props.HandleRefreshTable} /> */}

            </ul>
        </div>

    );
}

export default ContorlsBarV2;